import Lenis from "lenis";

// Initialize Lenis
export const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.45,
});

// Listen for the scroll event and log the event data
lenis.on("scroll", (e) => {
    // console.log(e);
});

export const lenisOnChangePage = () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');
    const slideSideElm = document.querySelector(".Sidebard__innerSide");

    // クリックハンドラーを別の関数として定義するよ
    const handleClick = (e) => {
        e.preventDefault();
        const offs = -parseFloat(window.getComputedStyle(slideSideElm)["top"]);
        lenis.scrollTo(`#${e.currentTarget.href.split("#")[1]}`, {
            offset: offs ? offs - 10 : -10,
        });
    };

    // イベントリスナーを追加
    anchorLinks.forEach((link) => {
        link.addEventListener("click", handleClick);
    });

    // クリーンアップ関数を返すよ
    return () => {
        anchorLinks.forEach((link) => {
            link.removeEventListener("click", handleClick);
        });
    };
};
